import React from 'react'
import "./Dialog.css"

import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Dialog = ({ title, children, onDialogHandler,showHeader=true }) => {

    const onActionHandler = (actionType) => {
        onDialogHandler(actionType);
    }

  return (
    <div className="Dialog-container">
      <div className="dialog-wrapper">
        {showHeader && (
          <div className="dialog-header">
            <h1 className="dialog-title">{title}</h1>
            <FontAwesomeIcon
              icon={faXmark}
              className="dialog-dismiss"
              onClick={() => onActionHandler("cancel")}
            />
          </div>
        )}

        <div className="dialog-content">{children}</div>

        <div className="dialog-footer"></div>
      </div>
    </div>
  );
};

export default Dialog